const isMainNavEnabled = false;

export default [
    {
        path: 'overview',
        name: 'Overview',
        redirect : "helloworld",
    },
    {
        path: 'home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "custom-left-nav-home" */ '../views/Home.vue'),
        meta: {
            mainNavEnabled: isMainNavEnabled,
        },
    },
    {
        path: 'testpage',
        name: 'Test Page',
        component: () => import(/* webpackChunkName: "custom-left-nav-testnav" */ '../views/TestNav.vue'),
        meta: {
            mainNavEnabled: isMainNavEnabled,
        },
    },    
    {
        path: 'apphelp',
        name: 'App Help',
        component: () => import(/* webpackChunkName: "custom-left-nav-help" */ '../views/Help.vue'),
        meta: {
            mainNavEnabled: isMainNavEnabled,
        },
    },
    {
        path: 'config',
        name: 'Config',
        component: () => import(/* webpackChunkName: "custom-left-nav-config" */ '../views/Config.vue'),
        meta: {
            mainNavEnabled: isMainNavEnabled,
        },
    },
    {
        path: 'help',
        name: 'Help',
        component: () => import(/* webpackChunkName: "custom-left-nav-global-help" */ '@/_views/Help.vue'),
        meta: {
            mainNavEnabled: isMainNavEnabled,
        },
    },
]
